import { enableProdMode } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';import { LocalizationService } from 'projects/libs/levero-core/src/lib/localization/localization.service';
import { loadTranslations } from '@angular/localize';

import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// load translations before starting app
// see https://github.com/loclapp/locl/issues/8
LocalizationService.init(environment).then((translations) => {
  if (!environment.production) {
    console.log('Loaded translations: ', translations);
  }

  // set translations
  loadTranslations(translations || {});

  // start the angular app
  import('./app/app.module').then(module => {
    platformBrowser()
      .bootstrapModule(module.AppModule)
      .catch(err => console.error(err));
  });
});


import 'hammerjs';
